import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ActionPayload {
  selectedCustomer: { customerId: string; customerName: string };
}

const initialState: ActionPayload = {
  selectedCustomer: { customerId: "", customerName: "" },
};

const CustomerAndGroups = createSlice({
  name: "CustomerAndGroups",
  initialState,
  reducers: {
    setSelectedCustomer: (
      state: any,
      action: PayloadAction<{ customerId: string; customerName: string }>,
    ) => {
      state.selectedCustomer = action.payload;
    },
  },
});

export const { setSelectedCustomer } = CustomerAndGroups.actions;
export default CustomerAndGroups;
